<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="item_title">站点</span>
        <el-autocomplete
          v-model="parameterNames.channel_code_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          style="width: 250px"
          @focus="current = '站点'"
          @select="handleSelect"
          @clear="parameter.channel_code = null"
        />
      </div>
      <div class="item">
        <span class="item_title">平台</span>
        <el-autocomplete
          v-model="parameterNames.platform_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '平台'"
          @select="handleSelect"
          @clear="platform_id = null"
        />
      </div>
      <div class="item">
        <span class="item_title">投放组</span>
        <el-autocomplete
          v-model="parameterNames.release_group_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '投放组'"
          @select="handleSelect"
          @clear="release_group_id = null"
        />
      </div>
      <div class="item">
        <span class="item_title">投手</span>
        <el-autocomplete
          v-model="parameterNames.pitcher_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '投手'"
          @select="handleSelect"
          @clear="pitcher_id = null"
        />
      </div>
      <div class="item">
        <span class="item_title">书籍归属</span>
        <el-autocomplete
          v-model="parameterNames.book_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '书籍归属'"
          @clear="book_id = null"
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="item_title">书名</span>
        <el-autocomplete
          v-model="parameterNames.alias_book_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '书名'"
          @clear="alias_book_id = null"
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="item_title">投放位置</span>
        <el-autocomplete
          v-model="parameterNames.position_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '投放位置'"
          @clear="position_id = null"
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="item_title">日期</span>
        <el-date-picker
          v-model="date"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </div>
      <el-button
        style="height: 37px"
        type="primary"
        icon="el-icon-search"
        @click="search()"
      >搜索</el-button>
      <el-button
        style="height: 37px"
        type="primary"
        icon="el-icon-refresh-left"
        @click="reset"
      >重置</el-button>
      <el-button
        style="height: 37px"
        type="primary"
        icon="el-icon-bottom"
        @click="reportExport"
      >导出报表</el-button>
      <el-button
        style="height: 37px"
        type="primary"
        icon="el-icon-bottom"
        @click="reportExxiter"
      >导出</el-button>
      <el-button
        style="height: 37px"
        type="primary"
        icon="el-icon-bottom"
        @click="reportAdq"
      >广告主消耗导出</el-button>
    </div>
    <div class="content1">
      <div>合计</div>
      <div>
        <div>新用户充值（扣除佣金）：</div>
        <div>
          {{
            tableData.total_data && tableData.total_data.new_user_recharge
              ? tableData.total_data.new_user_recharge
              : 0
          }}
        </div>
      </div>
      <div>
        <div>消耗：</div>
        <div>
          {{
            tableData.total_data && tableData.total_data.total_consume
              ? tableData.total_data.total_consume
              : 0
          }}
        </div>
        <!-- <div v-if="total_data.contrast && total_data.contrast!==0" :class="{'color1': total_data.is_contrast,'color2': !total_data.is_contrast}">
          <div>{{ total_data.is_contrast ? '↑' : '↓' }}</div>
          <div>{{ total_data.is_contrast ? total_data.contrast : total_data.contrast *(-1) }}%</div>
        </div> -->
      </div>
      <div>
        <div>新用户roi：</div>
        <div>
          {{
            tableData.total_data && tableData.total_data.new_user_roi
              ? tableData.total_data.new_user_roi
              : 0
          }}
        </div>
        <!-- <div v-if="total_data.rio && total_data.rio!==0" :class="{'color1': total_data.is_rio,'color2': !total_data.is_rio}">
          <div>{{ total_data.is_rio ? '↑' : '↓' }}</div>
          <div>{{ total_data.is_rio ? total_data.rio : total_data.rio *(-1) }}%</div>
        </div> -->
      </div>
    </div>
    <div>
      <el-table
        ref="tableRef"
        v-loading="loading"
        :data="tableData.list"
        max-height="650"
        style="width: 100%"
        border
        @sort-change="sortChange"
      >
        <el-table-column
          prop="channel_date"
          label="日期"
          width="150"
        />
        <el-table-column
          prop="release_group_name"
          label="投放组"
          width="120"
        />
        <!-- <el-table-column
          prop="operation_group_name"
          label="运营组"
          width="120"
        /> -->
        <el-table-column
          prop="pitcher_name"
          label="投手姓名"
        />
        <el-table-column
          prop="platform_name"
          label="书城平台"
          width="120"
        />
        <el-table-column
          prop="position_name"
          label="投放位置"
        />
        <el-table-column
          prop="belong_name"
          label="归属书籍"
          width="120"
        />
        <el-table-column
          prop="novel_name"
          label="书名"
          width="120"
        />
        <el-table-column
          prop="wechat_names"
          label="站点"
          width="150"
        >
          <template scope="scope">
            <div style="display: flex">
              <ExpandClose :my-values="JSON.parse(scope.row.channel_names)" />
              <el-button
                id="copyText"
                plain
                style="height: 30px"
                type="primary"
                size="mini"
                @click="copywechatname(scope.row)"
              >复制</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="roi_standard"
          label="ROI标准"
        />
        <el-table-column
          prop="compliance_rate"
          label="ROI达标率"
          width="120"
        >
          <template scope="scope"> {{ scope.row.compliance_rate }}% </template>
        </el-table-column>
        <el-table-column
          prop="consume"
          label="消耗"
          width="110"
          sortable="custom"
        >
          <template scope="scope">
            <div>
              <span v-if="!(activeItem && activeItem.id === scope.row.id)">{{
                scope.row.consume
              }}</span>
              <input
                v-else
                v-model="activeText"
                type="number"
                autofocus
                style="width: 87px; padding: 5px; border: 1px solid #ccc"
                @blur="blur1"
              >
              <i
                v-if="!(activeItem && activeItem.id === scope.row.id)"
                class="el-icon-edit"
                style="margin-left: 13px; font-size: 19px; cursor: pointer"
                @click="
                  ;(activeItem = scope.row), (activeText = scope.row.consume)
                "
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="hour_consume_diff"
          label="时速"
          width="110"
          sortable="custom"
        >
          <template scope="scope">
            <div v-if="scope.row.channel_date == nowDate">
              {{ scope.row.hour_consume_diff }}
              <span
                v-if="scope.row.hour_consume_diff_trend === 'up'"
                style="color: red"
              >↑</span>
              <span
                v-else-if="scope.row.hour_consume_diff_trend === 'down'"
                style="color: green"
              >↓</span>
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="new_user_recharge_after_sp"
          label="新用户充值（扣除佣金）"
          width="200"
          sortable="custom"
        >
          <template scope="scope">
            <span>{{ Object.keys(scope.row.new_user_recharge_after_sp)[0] }}: </span>
            <span style="color: red;font-weight: bold;">{{ Object.values(scope.row.new_user_recharge_after_sp)[0] }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="new_user_recharge_after_sp"
          label="当日总充值(扣佣后)"
          width="200"
          sortable="custom"
          align="center"
        >
          <template scope="scope">
            <div>
              <span>{{ scope.row.today_recharge_commission }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="new_user_recharge_after_sp"
          label="新用户充值（扣除佣金）"
          width="200"
          sortable="custom"
        >
          <template scope="scope">
            <div
              v-for="(value, key) in scope.row.new_user_recharge_after_sp"
              :key="key"
            >
              <span>{{ key }}: </span>
              <span :style="{ color: 'red', fontWeight: 'bold' }">{{
                value
              }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="new_user_roi"
          label="新用户roi"
          width="120"
        >
          <template scope="scope">
            <span style="color: red; font-weight: bold">{{ scope.row.new_user_roi }}%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="payment_growth_rate"
          label="付费增长率"
          width="120"
        >
          <template scope="scope">
            {{ scope.row.payment_growth_rate }}%
          </template>
        </el-table-column>
        <el-table-column
          prop="merits"
          label="有效绩效"
          width="120"
        />
        <!-- <el-table-column prop="scan_follow_count" label="企微客服人数" width="150" sortable="custom" />
        <el-table-column prop="scan_follow_cost" label="企微客服成本" width="150" sortable="custom" />
        <el-table-column prop="from_follow_count" label="公众号关注人数" width="160" sortable="custom" />
        <el-table-column prop="from_follow_cost" label="公众号关注成本" width="160" sortable="custom" /> -->
      </el-table>
    </div>
    <el-dialog
      title="导出"
      :visible.sync="dialogVisibler"
      :destroy-on-close="true"
      width="30%"
    >
      <reportdialog
        ref="themeview"
        @updata="updata"
      />
    </el-dialog>
    <pagination-right
      :total="tableData.count"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import {
  getReportListNovelSite,
  getPlatform,
  getReleaseGroupListNovel,
  getListOfPitchersInTheLaunchGroupNovel,
  getTitleListNovel,
  getBookOwnershipListNovel,
  dropLocationListNovel,
  exportReportNovelsite,
  modifyConsumptionNovelSite,
  getTheListOfOfficialAccountNovelSite,
  exportbinddataadvertiser
} from '@/api/newLaunchGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import ExpandClose from '@/components/ExpandClose/index.vue'
import reportdialog from './components/reportdialog.vue'
// import { ElStep } from 'element-ui/types/step'
export default {
  components: {
    PaginationRight,
    ExpandClose,
    reportdialog
    /* Details */
  },
  data() {
    return {
      tableData: {},
      total_data: {
        rio: null,
        contrast: null,
        is_rio: false,
        is_contrast: false
      },
      loading: false,
      parameter: {
        page: 1,
        pageSize: 10,
        channel_code: null,
        release_group_id: null,
        pitcher_id: null,
        alias_book_id: null,
        book_id: null,
        position_id: null
      },
      parameterNames: {
        channel_code: null, // 公众号
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手
        alias_book_id_name: null, // 书名
        book_id_name: null, // 书籍归属
        position_id_name: null, // 投放位置
        channel_code_name: null
      },
      order_by: {}, // 表格数据排序
      current: null,
      date: [this.getNowFormatDate(window.Date.now()), this.getNowFormatDate(window.Date.now())],
      nowDate: this.getNowFormatDate(window.Date.now()),
      activeItem: null,
      activeText: null,
      drawerItem: {},
      dialogVisibler: false,
      hasSearched: []
    }
  },
  created() {
    window.aa = this
    this.getDataList()
  },
  methods: {
    copywechatname(data) {
      const newdata = data.adq_advertiser
      if (newdata.length >= 1) {
        const arr = []
        newdata.map(item => {
          // if (item.agent_name) {
          const formatStr = `${item.account_name}-${item.account_id}-${item.agent_name}`
          arr.push(formatStr)
          // } else {
          //   const idStr = `${item.account_id}`
          //   arr.push(idStr)
          // }
        })
        const str = arr.join(',').trim()
        if (!navigator.clipboard) {
          const dummyInput = document.createElement('textarea')
          dummyInput.value = str
          dummyInput.style.left = '-9999px'
          dummyInput.style.top = '-9999px'
          dummyInput.style.textAlign = 'left'
          dummyInput.style.whiteSpace = 'pre-line'
          document.body.appendChild(dummyInput)
          dummyInput.select()
          document.execCommand('copy')
          document.body.removeChild(dummyInput)
        } else {
          navigator.clipboard.writeText(str)
        }
      }
    },
    // 获取数据列表
    async getDataList(obj = {}) {
      this.loading = true
      const ob1 = Object.keys(obj).length ? obj : this.parameter
      for (const item in ob1) {
        if (Object.prototype.toString.call(ob1[item]) === '[object Object]') {
          ob1[item] = ob1[item].address
        }
      }
      const data = await getReportListNovelSite({
        ...ob1,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null,
        order_by: this.order_by && this.order_by.field && this.order_by.order ? this.order_by : null
      })
      this.tableData = data.data
      // this.total_data.contrast = Number(data.data.total_data.consume_contrast.split('%')[0])
      // this.total_data.rio = Number(data.data.total_data.roi_contrast.split('%')[0])
      // if (this.total_data.contrast > 0) {
      //   this.total_data.is_contrast = true
      // } else {
      //   this.total_data.is_contrast = false
      // }
      // if (this.total_data.rio > 0) {
      //   this.total_data.is_rio = true
      // } else {
      //   this.total_data.is_rio = false
      // }
      this.loading = false
    },
    reportExxiter() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        this.$refs.themeview.send()
      })
    },
    updata() {
      this.dialogVisibler = false
      this.$message({
        message: '操作成功，请在导出列表下载',
        type: 'success'
      })
    },
    // 修改
    modify(row) {
      this.dialogVisible = true
      this.drawerItem = row
    },

    // 分页
    fetchPageSize(s) {
      this.parameter.pageSize = s
      this.search(true)
    },

    // 分页
    fetchCurrentPage(s) {
      this.parameter.page = s
      this.search(true)
    },

    // 搜索
    async querySearchAsync(queryString, cb) {
      let currentFunc = null
      const obj = {
        投放组: 'release_group_name',
        投手: 'user_name',
        书籍归属: 'book_name',
        书名: 'novel_name',
        投放位置: 'position_name',
        站点: 'channel_code_name',
        平台: 'platform_name'
      }

      switch (this.current) {
        case '投放组':
          currentFunc = getReleaseGroupListNovel
          break
        case '投手':
          currentFunc = getListOfPitchersInTheLaunchGroupNovel
          break
        case '书名':
          currentFunc = getTitleListNovel
          break
        case '书籍归属':
          currentFunc = getBookOwnershipListNovel
          break
        case '投放位置':
          currentFunc = dropLocationListNovel
          break
        case '站点':
          currentFunc = getTheListOfOfficialAccountNovelSite
          break
        case '平台':
          currentFunc = getPlatform
          break
      }
      if (!currentFunc) {
        return
      }
      if ((this.current === '投手' && !this.parameter.release_group_id) || (this.current === '书名' && !this.parameter.book_id)) {
        const obj1 = {
          投手: '请先选投放组，才能选投手',
          书名: '请先选择书籍归属，才能选书名'
        }
        this.$message({
          message: obj1[this.current],
          type: 'warning'
        })
        cb()
        return
      }
      let result = null
      console.log('item:', queryString)
      if (this.current === '站点' && queryString !== null) {
        result = queryString.replace(/\([^()]+\)/g, '')
      }
      if (this.current === '站点' && this.hasSearched.length !== 0) {
        var restaurants = this.hasSearched
        var results = result ? restaurants.filter(this.createFilter(result)) : restaurants
        // 调用 callback 返回建议列表的数据
        console.log('results:', results)
        // cb(results)
        cb(
          results.map(item => {
            return item
          })
        )
        return
      }

      const data = await currentFunc({
        name: this.current !== '站点' ? queryString : null,
        channel_name: this.current === '站点' ? result : null,
        group_id: this.current === '投手' && Object.prototype.toString.call(this.parameter.release_group_id) === '[object Object]' ? this.parameter.release_group_id.address : this.parameter.release_group_id,
        book_belong_id: this.parameter.book_id && Object.prototype.toString.call(this.parameter.book_id) === '[object Object]' ? this.parameter.book_id.address : this.parameter.book_id,
        type: this.current === '投放组' ? 2 : null
      })
      cb(
        data.data.list.map(item => {
          if (this.current === '站点') {
            this.hasSearched.push({
              value: this.current === '站点' ? `${item.channel_name}(${item.platform_str})` : this.current === '平台' ? item.name : item[obj[this.current]],
              address: this.current === '站点' ? item.channel_code : item.id
            })
          }
          return {
            value: this.current === '站点' ? `${item.channel_name}(${item.platform_str})` : this.current === '平台' ? item.name : item[obj[this.current]],
            address: this.current === '站点' ? item.channel_code : item.id
          }
        })
      )
    },
    createFilter(queryString) {
      return restaurant => {
        return restaurant.value.toLowerCase().includes(queryString.toLowerCase())
      }
    },
    // 选中哪一项
    handleSelect(item) {
      switch (this.current) {
        case '投放组':
          this.parameter.release_group_id = item
          break
        case '投手':
          this.parameter.pitcher_id = item
          break
        case '书名':
          this.parameter.alias_book_id = item
          break
        case '书籍归属':
          this.parameter.book_id = item
          break
        case '投放位置':
          this.parameter.position_id = item
          break
        case '站点':
          this.parameter.channel_code = item
          break
        case '平台':
          this.parameter.platform_id = item
          break
      }
    },

    // 搜索
    search(value) {
      console.log(8888888888888888)
      value || (this.parameter.page = 1)
      // 清空排序
      console.log(' !value :', !value, this.order_by.field || this.order_by.order)
      !value && (this.order_by.field || this.order_by.order) ? this.sortOrderChang() : null
      const obj = {
        channel_code: 'channel_code_name',
        release_group_id: 'release_group_id_name',
        pitcher_id: 'pitcher_id_name',
        alias_book_id: 'alias_book_id_name',
        book_id: 'book_id_name',
        position_id: 'position_id_name',
        platform_id: 'platform_name'
      }
      const keys = Object.keys(this.parameter)
      console.log('keys----:', this.parameter)
      const obj1 = {}
      keys.map((key, index) => {
        if (this.parameter[key] && this.parameter[key].value === this.parameterNames[obj[key]] && key !== 'page' && key !== 'pageSize') {
          if (Object.prototype.toString.call(this.parameter[key]) === '[object Object]') {
            obj1[key] = this.parameter[key].address
          } else {
            obj1[key] = this.parameter[key]
          }
          // obj1[key] = this.parameter[key].address
        } else {
          obj1[key] = this.parameter[key]
        }
        // else if (key !== 'page' && key !== 'pageSize') {
        //   // key !== 'channel_code'
        //   obj1[key] = null
        // }
      })

      console.log('obj1:', obj1)
      value === '导出' || this.getDataList(obj1)
      return obj1
    },
    // 清空排序
    sortOrderChang() {
      this.order_by = {}
      this.$refs.tableRef.clearSort()
    },
    // 重置
    reset(value) {
      this.parameter = {
        page: 1,
        pageSize: 10,
        channel_code: null,
        release_group_id: null,
        pitcher_id: null,
        alias_book_id: null,
        book_id: null,
        position_id: null,
        platform_id: null
      }
      this.parameterNames = {
        channel_code: null, // 渠道号
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手
        alias_book_id_name: null, // 书名
        book_id_name: null, // 书籍归属
        position_id_name: null, // 投放位置
        channel_code_name: null,
        platform_name: null
      }
      this.date = []
      this.current = null
      this.sortOrderChang()
      this.getDataList()
    },

    // 导出报表
    async reportExport() {
      const obj = this.search('导出')
      await exportReportNovelsite({
        ...obj,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null
      })
      this.$message({
        message: '已在后台中导出',
        type: 'success'
      })
      // this.reset('no')
    },
    // 导出报表
    async reportAdq() {
      const obj = this.search('导出')
      await exportbinddataadvertiser({
        ...obj,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null
      })
      this.$message({
        message: '已在后台中导出',
        type: 'success'
      })
      // this.reset('no')
    },
    async blur1() {
      if (this.activeItem.consume !== this.activeText) {
        try {
          await modifyConsumptionNovelSite({
            id: this.activeItem.id,
            consume: this.activeText
          })
          this.$message({
            message: '修改消耗成功',
            type: 'success'
          })
          this.getDataList()
        } catch (err) {
          this.activeItem = null
          this.activeText = null
        }
      }
      this.activeItem = null
      this.activeText = null
    },

    getNowFormatDate(timeStamp) {
      var date = new Date(timeStamp)
      var seperator1 = '-'
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate
      return currentdate
    },

    handleSplicing(new_user_recharge_after_sp) {
      const arr = []
      for (const key in new_user_recharge_after_sp) {
        let value = new_user_recharge_after_sp[key]
        console.log('value:', value)
        // 检查冒号后面的内容
        // 冒号后面的内容
        // 将冒号后面的内容设置为红色，其他内容设置为黑色
        value = value.replace(value, `<span style="color: red;">${value}</span>`)
        arr.push(`${key}: ${value}`)
      }
      return arr
    },
    // 列表排序
    sortChange(cell) {
      this.order_by['order'] = !cell.order ? cell.order : cell.order === 'ascending' ? 'asc' : 'desc'
      this.order_by['field'] = !cell.order ? cell.order : this.handleSort(cell.column.label)
      this.search('排序')
    },
    handleSort(label) {
      let field = ''
      switch (label) {
        case '消耗':
          field = 'consume'
          break
        case '时速':
          field = 'hour_consume_diff'
          break
        case '新用户充值（扣除佣金）':
          field = 'new_user_recharge'
          break
        case '企微客服人数':
          field = 'scan_follow_count'
          break
        case '企微客服成本':
          field = 'scan_follow_cost'
          break
        case '公众号关注人数':
          field = 'from_follow_count'
          break
        case '公众号关注成本':
          field = 'from_follow_cost'
          break
      }
      return field
    }
  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
.content {
  .item {
    display: flex;
    align-items: center;
    .item_title {
      display: inline-block;
      width: 100px;
    }
    .item_input {
      width: 200px;
    }
  }
}
textarea {
  text-align: left;
  white-space: pre-line;
}
.selectionArea {
  display: flex;
  flex-wrap: wrap;
  .item {
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
    .item_title {
      margin-right: 10px;
      display: inline-block;
    }
    .item_input {
      width: 200px;
    }
  }
}

.powder {
  background: rgb(248, 216, 216);
}
.green {
  background: rgb(52, 229, 54);
}
.yellow {
  background: rgb(255, 247, 173);
}
.blue {
  background: rgb(158, 211, 252);
}
.red {
  background: #ffa500;
}
.magRig {
  margin-right: 10px;
}
.magLfte {
  margin-left: 10px;
}
.chong {
  display: inline-block;
  width: 13px;
  height: 86%;
  margin-left: 6px;
}
.mybox {
  margin-left: 20px;
  display: flex;
  align-items: center;
}
</style>

<style>
.publicItems .el-dialog {
  margin-top: 6vh !important;
}
.content1 {
  padding: 13px;
  color: #000;
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: bold;
}
.content1 > div:nth-child(1) {
  margin-right: 7rem;
}
.content1 > div {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 3rem;
}
.content1 > div > div:nth-child(2) {
  color: rgb(138, 37, 37);
}
.content1 > div > div:nth-child(3) {
  display: flex;
  align-items: flex-end;
  font-weight: bolder;
  margin-left: 10px;
}
.content1 > div > div > div:nth-child(2) {
  font-size: 0.5rem;
  margin-left: 2px;
}
.color2 {
  color: #0ebb0e;
}
.color1 {
  color: #ef0505;
}
</style>
